import { createApi } from '@core/fetch'

export default {
  homeShowModulesApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/showModule'
  ),
  tipsPopup: createApi('/p/wedding/Admin/APITool/tipsPopup'),
  // 三大升级小助手
  groupUpgradeTips: createApi(
    '/p/wedding/mainAdmin/APIMerchant/fourRoleUpgradeItems'
  ),
  // 开店助手模块
  shopAssistantApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/shopAssistant'
  ),
  // 设置团队权限
  fourRoleGroupSetting: createApi.post(
    '/p/wedding/mainAdmin/APIMerchant/fourRoleGroupSetting'
  ),
  /** 常用功能模块 */
  commonFunctionApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/commonFunction'
  ),
  /** 平台活动模块 */
  getPlatformActivityApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/platformActivity'
  ),
  /** 顶部提示 */
  getToptilApi: createApi('/p/wedding/index.php/Admin/APIMerchant/topTip'),

  /** 智推宝弹窗提示 */
  certifyDataApi: createApi('/p/wedding/Admin/APIMerchant/certify_data')
}
